import { produce } from "immer";
import {
  GET_ASSESSMENT_TEMPLATES,
  GET_ASSESSMENT_TEMPLATES_SUCCESS,
  GET_ASSESSMENT_TEMPLATES_FAILURE,
  //
  GET_ASSESSMENT_TEMPLATE,
  GET_ASSESSMENT_TEMPLATE_SUCCESS,
  GET_ASSESSMENT_TEMPLATE_FAILURE,
  //
  SAVE_ASSESSMENT_TEMPLATE,
  SAVE_ASSESSMENT_TEMPLATE_SUCCESS,
  SAVE_ASSESSMENT_TEMPLATE_FAILURE,
  //
  DELETE_ASSESSMENT_TEMPLATE,
  DELETE_ASSESSMENT_TEMPLATE_SUCCESS,
  DELETE_ASSESSMENT_TEMPLATE_FAILURE,
  //
  TOGGLE_ASSESSMENT_MODAL,
  TEMPLATE_TYPE_NEEDS,
  TEMPLATE_TYPE_RISK,
  TEMPLATE_TYPE_GENERIC,
  TEMPLATE_TYPE_SAFEGUARDING,
  TEMPLATE_TYPE_INCIDENT,
  TEMPLATE_TYPE_CARE_PLAN,
  TEMPLATE_TYPE_CARE_PLAN_ACTION,
  TEMPLATE_TYPE_MEDICAL_CONDITION,
  TEMPLATE_TYPE_SCREENING,
  TEMPLATE_TYPE_CAPACITY,
  TEMPLATE_TYPE_DOLS,
  TEMPLATE_TYPE_CONSENT,
} from "./constants";

const createInitialState = () => ({
  isFetchingTemplates: false,
  templates: [],
  isFetchingTemplate: false,
  currentTemplate: null,
  isSubmitting: false,
  isDeleting: false,
  modal: {
    open: false,
    isEditing: false,
    template: null,
  },
});

export const initialState = {
  [TEMPLATE_TYPE_NEEDS]: createInitialState(),
  [TEMPLATE_TYPE_RISK]: createInitialState(),
  [TEMPLATE_TYPE_GENERIC]: createInitialState(),
  [TEMPLATE_TYPE_SAFEGUARDING]: createInitialState(),
  [TEMPLATE_TYPE_INCIDENT]: createInitialState(),
  [TEMPLATE_TYPE_CARE_PLAN]: createInitialState(),
  [TEMPLATE_TYPE_CARE_PLAN_ACTION]: createInitialState(),
  [TEMPLATE_TYPE_MEDICAL_CONDITION]: createInitialState(),
  [TEMPLATE_TYPE_SCREENING]: createInitialState(),
  [TEMPLATE_TYPE_CAPACITY]: createInitialState(),
  [TEMPLATE_TYPE_DOLS]: createInitialState(),
  [TEMPLATE_TYPE_CONSENT]: createInitialState(),
};

const ResidentAssessmentTemplateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { templateType } = action;

    // If no templateType, return state as-is
    if (!templateType || !draft[templateType]) {
      return state;
    }

    const templateState = draft[templateType];

    switch (action.type) {
      // GET TEMPLATES LIST
      case GET_ASSESSMENT_TEMPLATES:
        templateState.isFetchingTemplates = true;
        templateState.templates = [];
        break;
      case GET_ASSESSMENT_TEMPLATES_SUCCESS:
        templateState.isFetchingTemplates = false;
        templateState.templates = action.payload;
        break;
      case GET_ASSESSMENT_TEMPLATES_FAILURE:
        templateState.isFetchingTemplates = false;
        templateState.templates = [];
        break;
      // GET TEMPLATE
      case GET_ASSESSMENT_TEMPLATE:
        templateState.isFetchingTemplate = true;
        templateState.currentTemplate = null;
        break;
      case GET_ASSESSMENT_TEMPLATE_SUCCESS:
        templateState.isFetchingTemplate = false;
        templateState.currentTemplate = action.payload;
        break;
      case GET_ASSESSMENT_TEMPLATE_FAILURE:
        templateState.isFetchingTemplate = false;
        templateState.currentTemplate = null;
        break;
      // SAVE TEMPLATE
      case SAVE_ASSESSMENT_TEMPLATE:
        templateState.isSubmitting = true;
        break;
      case SAVE_ASSESSMENT_TEMPLATE_SUCCESS:
        templateState.isSubmitting = false;
        break;
      case SAVE_ASSESSMENT_TEMPLATE_FAILURE:
        templateState.isSubmitting = false;
        break;
      // DELETE TEMPLATE
      case DELETE_ASSESSMENT_TEMPLATE:
        templateState.isDeleting = true;
        break;
      case DELETE_ASSESSMENT_TEMPLATE_SUCCESS:
        templateState.isDeleting = false;
        break;
      case DELETE_ASSESSMENT_TEMPLATE_FAILURE:
        templateState.isDeleting = false;
        break;
      // TOGGLE MODAL
      case TOGGLE_ASSESSMENT_MODAL:
        templateState.modal = action.payload;
        break;
      default:
        return state;
    }
  });

export default ResidentAssessmentTemplateReducer;
